import { BreadCrumb } from "../../../../components";
import Layout from "../../../../components/layouts/DatoDocsLayout";
import Head from "next/head";
import { Flex } from "@radix-ui/themes";
import { DOCUMENTATION_CATEGORIES, getDocmentation } from "../../../../components/helpers";
import { RenderStructuredText } from "../../../../components/RenderStructuredText";

export default function Documentation({ user, mobileMenuIsOpen, setMobileMenu, handleToast, data, title, slug }) {
    return <><Head>
        <link
            rel="canonical"
            href={`https://www.covalenthq.com/docs/unified-api/${slug}/`}
            key="canonical" />            
        <title>{title} | Unified API | Covalent</title>
    </Head>
    <Layout user={user} mobileMenuIsOpen={mobileMenuIsOpen} setMobileMenu={setMobileMenu} handleToast={handleToast}>
        <article>
            <Flex gap="3" direction="column">
                <BreadCrumb title={title}/>
                <RenderStructuredText post={data}/>
            </Flex>
        </article>
    </Layout></>;

}

export async function getStaticProps({params}) {
    const {data} = await getDocmentation('quickstart/' + params.slug, DOCUMENTATION_CATEGORIES.UNIFIED_API);
    return {
        props: {
            slug: data.documentation.slug,
            title: data.documentation.title,
            data: data.documentation,
            component: "Documentation"
        },
    };
}

export async function getStaticPaths() {
    const paths = [
        {params: {slug: "typescript-sdk"}},
        {params: {slug: "goldrush-kit"}},
        {params: {slug: "goldrush-templates"}},
    ];
    return {
        paths: paths,
        fallback: false,
    };
}
